import { Directive, HostListener, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { CustomToastService } from 'src/app/core/services/custom-toast.service';
import { ValidationService } from './validation.service';

@Directive({
  selector: '[appCustomValidator]',
  providers: [NgModel],
  standalone: false,
})
export class CustomValidatorDirective {
  @Input('appCustomValidator') validationRules: any = {};
  @Input() errorMessage!: string;
  @Input() resetRef!: NgModel;

  constructor(
    private model: NgModel,
    private toastr: CustomToastService,
  ) {}

  @HostListener('blur')
  mouseleave() {
    let validations: boolean[] = [];
    const value = this.resetRef?.value; // Ensure resetRef is defined

    for (const rule in this.validationRules) {
      const param = this.validationRules[rule];
      if (typeof (ValidationService as any)[rule] === 'function') {
        const validationFn = (ValidationService as any)[rule];
        validations.push(validationFn(value, param));
      }
    }

    let allValidationPassed = validations.every((result) => result);
    if (!allValidationPassed && this.resetRef.control.value) {
      this.toastr.error(this.errorMessage || 'Validation failed');
      // this.resetRef.control.setValue('');
      this.resetRef.control.markAsTouched();
      this.resetRef.control.updateValueAndValidity();
    }
  }
}
